import { useEffect, useState } from 'react';
import {createContext, useContext} from 'react'

export const ModalFormsContext = createContext();

export function ModalFormsProvider({ children }){
    const [changeVisibleContent, setChangeVisibleContent] = useState(0)
    const [formChangeVisibleContentFromNavigatorButtons, setFormChangeVisibleContentFromNavigatorButtons] = useState(-1)

    const [alertButtonToClickHim, setAlertButtonToClickHim] = useState({breathButton: false, index: -1})

    useEffect(() => {
      if(alertButtonToClickHim.breathButton === true)
        setTimeout(() =>{
          setAlertButtonToClickHim({breathButton: false, index: -1})
        }, 3000)
    }, [alertButtonToClickHim])


    return(
        <ModalFormsContext.Provider  
          value={
            { 
              changeVisibleContent, setChangeVisibleContent,
              formChangeVisibleContentFromNavigatorButtons, setFormChangeVisibleContentFromNavigatorButtons,
              alertButtonToClickHim, setAlertButtonToClickHim
            }
          }
        >
          { children }
        </ModalFormsContext.Provider>
    )
}


export function useModalForms() {
   const context = useContext(ModalFormsContext)

   if(!context) {
    throw new Error('useModalForms must be used within an Provider');
  } 

   return context
}